export interface UserProfileResponse {
  data: any;
  errorStatus: boolean;
  error: string;
}

export async function fetchUserProfileClient(): Promise<UserProfileResponse> {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_TERM ? `/${process.env.NEXT_PUBLIC_BASE_TERM}` : ""}/api/userProfile/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        data: {},
        errorStatus: true,
        error: errorData.error || 'Failed to fetch user profile',
      };
    }

    const data = await response.json();
    return { data, errorStatus: false, error: '' };
  } catch (error: any) {
    console.error('Error fetching user profile:', error);
    return {
      data: {},
      errorStatus: true,
      error: error.message || 'Network error occurred',
    };
  }
}

export async function updateUserProfileClient(payload: any): Promise<UserProfileResponse> {
  try {
    const hasFiles = Object.values(payload).some(value => value instanceof File);
    
    let body: FormData | string;
    let headers: HeadersInit = {};

    if (hasFiles) {
      const formData = new FormData();
      Object.keys(payload).forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null) {
          formData.append(key, payload[key]);
        }
      });
      body = formData;
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(payload);
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_BASE_TERM ? `/${process.env.NEXT_PUBLIC_BASE_TERM}` : ""}/api/userProfile/`, {
      method: 'PATCH',
      headers,
      body,
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        data: {},
        errorStatus: true,
        error: errorData.error || 'Failed to update user profile',
      };
    }

    const data = await response.json();
    return { data, errorStatus: false, error: '' };
  } catch (error: any) {
    console.error('Error updating user profile:', error);
    return {
      data: {},
      errorStatus: true,
      error: error.message || 'Network error occurred',
    };
  }
} 